import * as React from 'react';
import { toHex } from 'ui/common/hex-converter';
import styles from './fact-box.scss';
import {
  IconsConsequences,
  BadgeListActions,
  BadgeListAttachments,
  BadgeListConnectedCases,
  BadgeListComments,
  BadgeListCauses,
  BadgeListInvolvedPersons,
  BadgeListInvolvedDrugs,
  BadgeListIntegrityStatus,
  BadgeListIntegrityStatusBarrierEval,
  BadgeListChecklists,
  BadgeListAssessments,
  IconBowtie
} from 'app/area/case/components/fact-box/fact-items';
import {sectionFor} from 'app/area/case/components/fact-box/section';
import { Thumbnail } from 'app/area/case/components/thumbnail/thumbnail';
import { FactBoxProps } from 'app/area/case/components/fact-box/types';
import { FactBadge } from 'app/area/case/components/fact-box/renderers';
import { createFactboxProps } from 'app/area/case/components/fact-box/props-builder';
import { tableName as tbl } from 'app/area/case/case-data-model';
import { ReportCategory } from 'app/area/case-report/case-listing/types';

const FactboxItems = (props:FactBoxProps) => {

  const {
    totalsExceptActions,
    numberOfActions,
    numberOfAssessments,
    numberOfAttachments,
    numberOfCauses,
    numberOfChecklistItems,
    numberOfComments,
    numberOfConnectedCases,
    numberOfConsequences,
    numberOfInvolvedDrugs,
    numberOfInvolvedPersons,
    badgePropsRiskArea,
    badgePropsRiskAreaRest    
  } = createFactboxProps(props);

  const {
    riskArea,
    riskWeight,
    riskWeightRest,
    integrityStatus,
    integrityStatusBarrierEval,
    bowtieSupported
  } = props;

  const compact = String(props.className).indexOf('compact') !== -1;

  const wrapperStyleClass =
    !compact && numberOfConsequences && numberOfConsequences > 4
      ? styles.consequenceWide
      : '';

  const items = [
      numberOfConsequences > 0 && <IconsConsequences key={1} {...props as any} />,

      Number(riskWeight) > 0 &&
        <FactBadge key={3} badgeProps={badgePropsRiskArea} section={sectionFor(props, tbl.lossPotentialEvaluation)}
       url={props.url} />,

      Number(riskWeightRest) > 0 && <FactBadge key={4} badgeProps={badgePropsRiskAreaRest}
        section={sectionFor(props, tbl.lossPotentialResidualEvaluation)} url={props.url}/>,

      (numberOfActions > 0 && props.reportCategory !== ReportCategory.NumeratorReport) &&
        <BadgeListActions key={5} count={numberOfActions} {...props as any} />,

      numberOfAttachments > 0 && <BadgeListAttachments key={6} count={numberOfAttachments} {...props as any} />,

      numberOfConnectedCases > 0 && <BadgeListConnectedCases key={7} count={numberOfConnectedCases} {...props as any} />,
      
      bowtieSupported && <IconBowtie key={8} {...props as any} />,

      numberOfComments > 0 && <BadgeListComments key={9} count={numberOfComments} {...props as any} />,

      numberOfCauses > 0 && <BadgeListCauses key={10} count={numberOfCauses} {...props as any} />,

      numberOfInvolvedPersons > 0 && <BadgeListInvolvedPersons key={11} count={numberOfInvolvedPersons} {...props as any} />,

      numberOfInvolvedDrugs > 0 && <BadgeListInvolvedDrugs key={12} count={numberOfInvolvedDrugs} {...props as any} />,

      integrityStatus && !!integrityStatus.value && <BadgeListIntegrityStatus key={13} {...props as any} />,

      integrityStatusBarrierEval && !!integrityStatusBarrierEval.value &&
        <BadgeListIntegrityStatusBarrierEval key={14} {...props as any} />,

      numberOfChecklistItems > 0 && <BadgeListChecklists key={15} count={numberOfChecklistItems} {...props as any} />,

      numberOfAssessments > 0 && <BadgeListAssessments key={16} count={numberOfAssessments} {...props as any} />
  ].filter(i => i);

  const color = riskArea && riskArea.value && riskArea.backgroundColor ? riskArea.backgroundColor : undefined;

  return  items.length !== 0 ? <div
      className={`${styles.factBoxList} ${wrapperStyleClass} item-count-${totalsExceptActions}`}
      style={{ borderColor: toHex(color) }}>
      {items}
    </div> : null;
};

export const FactBox = (props: FactBoxProps) => {
  const items = FactboxItems(props);

  return (items || props.numberOfFiles) ? (
    <div
      id={`${props.componentId}`}
      className={`${props.className} ${styles.factBox}`}>
      <Thumbnail componentId={undefined} className={undefined} 
        uploadedFiles={props.uploadedFiles} loadBlob={props.loadBlob}/>
      {items}
    </div>
  ) : null;
};
